<template>
<div class="chapter">
<div class="inner_page">
<div class="cover">
<img alt="" src="OEBPS/images/9780812589085_cvi.png"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780812589085_epub_cvi_r1.vue?8eb00a48